export const FILTER_EVENTS = Object.freeze({
    APPLY: 'filter-apply',
    RESET: 'filter-reset',
    OPEN: 'filter-open',
    CLOSE: 'filter-close',
    CHANGE: 'filter-change',
    PRESENTATION_CHANGE: 'filter-presentation-change',
    COLLAPSE_CHANGE: 'filter-collapse-change',
});

export const FILTER_PRESENTATIONS = Object.freeze({
    DROPDOWN: 'dropdown',
    SECTION: 'section',
});

/**
 * Dispatches a consistent, cancelable filter event across shadow boundaries.
 *
 * @param {EventTarget} target
 * @param {string} type
 * @param {Record<string, unknown>} [detail]
 * @returns {boolean} false when a consumer canceled the event
 */
export function dispatchFilterEvent(target, type, detail = {}) {
    return target.dispatchEvent(
        new CustomEvent(type, {
            detail,
            bubbles: true,
            composed: true,
            cancelable: true,
        })
    );
}
